import React from "react";

import { Stack, TextField, ToggleButton, Typography, useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

import useLanguageHook from "containers/hooks/useLanguageHook";
import { Item, ItemType, OptionKey, SelectorItemTextType } from "@store/options/types";
import { useAppDispatch } from "index";
import * as optionsActions from "@store/options/actions";

// Component-specific props.
type ComponentProps = {
  item: Item;
  name: OptionKey;
};

function OptionItem(props: ComponentProps) {
  const { t } = useLanguageHook();
  const theme = useTheme();
  const item = props.item;
  const dispatch = useAppDispatch();

  /*
    [OptionKey.HideSensitiveData]: ToggleItem,
    [OptionKey.ShowFolderHierarchy]: ToggleItem,
    [OptionKey.ElementSize]: SelectorItem,
    [OptionKey.Grouping]: ToggleItem,
    [OptionKey.MultipleTimelines]: ToggleItem,
    [OptionKey.ShowFiles]: ToggleItem,
    [OptionKey.ShowImages]: ToggleItem,
    [OptionKey.ColorScheme]: SelectorItem,
    */
  switch (item.type) {
    case ItemType.toggleItem:
      return (
        <ListItem key={props.name} sx={{ paddingLeft: theme.spacing(2) }}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={item.value}
                onChange={() => dispatch(optionsActions.selectItem(props.name, !item.value))}
              />
            }
            label={t.Options[props.name]}
          />
        </ListItem>
      );
    case ItemType.selectorItem:
      return (
        <ListItem>
          <Stack direction={"column"} sx={{ width: "100%" }}>
            <Typography align="center">{t.Options[props.name]}</Typography>

            <ToggleButtonGroup
              orientation="vertical"
              color="primary"
              sx={{ width: "100%" }}
              value={item.value}
              exclusive
              size="small"
              onChange={(_event, nextView) => dispatch(optionsActions.selectItem(props.name, nextView))}
            >
              {item.options.map((d) => (
                <ToggleButton key={d} value={d}>
                  {t.Options.SelectorItemOptions[d as SelectorItemTextType] || d}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Stack>
        </ListItem>
      );
    case ItemType.numberItem:
      return (
        <ListItem key={props.name} sx={{ paddingLeft: 3 }}>
          <FormControlLabel
            control={
              <TextField
                color="primary"
                type="number"
                size="small"
                sx={{
                  marginRight: 1,
                  width: "4em",
                  padding: 0,
                  textAlign: "center",
                  "& input": {
                    paddingX: 0,
                    paddingY: 0.75,
                    minWidth: 0,
                    textAlign: "center",
                  },
                }}
                defaultValue={item.value}
                onChange={(e) => dispatch(optionsActions.selectItem(props.name, e.target.value))}
              />
            }
            label={t.Options[props.name]}
          />
        </ListItem>
      );
    default:
      throw new Error("TODO: implement");
  }

  /*
  if (typeof (item as SliderItem).step === 'number') {
    return (<ListItem
      key={props.name}
      sx={{ paddingLeft: theme.spacing(2) }}>
      <Grid container direction="row">
        <ListItemText primary={t.Options[props.name]} />
        <form noValidate>
          <Slider
            color="secondary"
            onChange={(_, value) => props.callback(props.name, value)}
            //marks={}
            aria-labelledby="discrete-slider"
            valueLabelDisplay="auto"
            value={item.value}
            step={item.step}
            min={item.start}
            max={item.end}
            style={{ width: '144px', marginLeft: '6px' }}
          //style={{marginBottom: "8px"}}
          />
        </form>
      </Grid>
    </ListItem>
    );
  } else if (item.kind === 'Range') {
    return (
      <ListItem
        key={props.name}
        sx={{ paddingLeft: theme.spacing(2) }}
      >
        <ListItemText primary={t.Options[props.name]} />
        <form noValidate>
          <TextField
            id="start"
            value={new Date(item.value).toISOString().slice(0, 10)}
            label="Day"
            type={'date'}
            style={{ width: '150px', paddingLeft: '0px' }}
            onChange={(e) => {
              props.callback(props.name, new Date(e.target.value === '' ? 0 : e.target.value).getTime());
            }}
            sx={{
              marginLeft: theme.spacing(1),
              marginRight: theme.spacing(1),
              width: 200,
            }
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </form >
      </ListItem >);
  } else if (item.kind === 'Selector') {
    return (

    );
  } else if (typeof item.value === 'boolean') {
    return (

  );
  } else if (item.kind === 'Input') {
    return (
      <ListItem key={props.name}
        sx={{ paddingLeft: theme.spacing(2) }}
        <TextField id="standard-basic"
          sx={{
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: 200,
          }}
          placeholder="Search"
          value={item.value}
          onChange={d => props.callback(props.name, d.target.value)} />
        <Tooltip title="Clear">
          <Button onClick={() => props.callback(props.name, '')}>
            <Clear />
          </Button>
        </Tooltip>
      </ListItem >
    );
}


throw new Error('Kind of Sidebar Item not known');
    */
}

export default OptionItem;
